import { takeEvery } from 'redux-saga/effects'

import { track } from '../actions'
import { googleTrack } from '../googleAnalytics'

export function handleError({ payload: { category, action, data } }) {
  try {
    googleTrack(category, action, data)
  } catch (err) {
    console.log('Analytics track error', err)
  }
}

export default function* errorSaga() {
  yield takeEvery(track.toString(), handleError)
}
